export default "__VITE_ASSET__BKBpY5xN__"